import ApiService from './api.service';
import { TokenService } from './token.service';

class AuthenticationError extends Error {
  constructor (errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const UserService = {
  /**
   * Login the user and store the access token to TokenService
   *
   * @returns access_token
   * @throws AuthenticationError
  **/
  login: async function (body) {
    try {
      const response = await ApiService.post(`${process.env.VUE_APP_BASE_URL}/usuarioUNI/login`, body);
      if (response.data.success) {
        TokenService.saveToken(response.data.data.token); // Debe ser response.data.data.token
        TokenService.saveRole('user');
        ApiService.setHeader();
        // Interceptor
        // ApiService.mount401Interceptor();
        return response.data.data.token;
      }
    } catch (error) {
      let errMessage;
      if (error.response.data.status === 'INCORRECT_PASSWORD') errMessage = 'Contraseña incorrecta, intenta nuevamente';
      else errMessage = error.response.data.message;
      throw new AuthenticationError(error.response.data.success, errMessage);
    }
  },

  /**
   * Login the user from a Company and store the access token to TokenService
   *
   * @returns access_token
   * @throws AuthenticationError
   */
  loginEmpresa: async function (body) {
    try {
      const response = await ApiService.post(`${process.env.VUE_APP_BASE_URL}/empresa/login`, body);
      if (response.data.success) {
        TokenService.saveToken(response.data.data.token);
        TokenService.saveRole('company');
        ApiService.setHeader();
        // Interceptor
        // ApiService.mount401Interceptor();
        return response.data.data.token;
      }
    } catch (error) {
      throw new AuthenticationError(error.response.data.success, error.response.data.message);
    }
  },

  loginAdmin: async function (body) {
    try {
      const response = await ApiService.post(`${process.env.VUE_APP_BASE_URL}/admin/login`, body);
      console.log(response.data);
      if (response.data.success) {
        TokenService.saveToken(response.data.data.token);
        ApiService.setHeader();
        // Interceptor
        // ApiService.mount401Interceptor();
        return response.data.data.token;
      }
    } catch (error) {
      throw new AuthenticationError(error.response.data.success, error.response.data.message);
    }
  },

  /**
   * Obtiene la lista de trabajos
   **/

  getJobList: async function () {
    const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/trabajo/listar`;
    const jobResponse = await ApiService.get(url);
    return jobResponse.data.data;
  },

  /**
   * Obtiene la información del perfil
   */

  getProfile: async function () {
    const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/perfil`;
    const profileResponse = await ApiService.get(url);

    return profileResponse.data.data;
  },

  uploadPhoto: async function (photoFile) {
    const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/foto/actualizar`;
    let formData = new FormData();
    formData.append('fotoPerfil', photoFile);
    let response = await ApiService.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response.data;
  },

  updateProfile: async function (body) {
    const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/perfil/actualizar`;
    let response = await ApiService.post(url, body);
    if (response.success || response.data.success) return response.data;
    else return response;
  },

  startTest: async function (body) {
    const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/test-adaptativo/iniciar`;
    let response = await ApiService.post(url, body);
    console.log(response);
  },

  getStateTest: async function () {
    const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/test-adaptativo/estado`;
    let response = await ApiService.get(url);
    return response.data;
  },

  getNextQuestion: async function () {
    const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/test-adaptativo/siguiente-pregunta`;
    let response = await ApiService.get(url);
    if (response.data.success) return response.data.data;
    else {
      if (response.data.status === 'TEST_FINALIZADO') {
        return response.data.status;
      }
      return response.data.message;
    }
  },

  submitQuestion: async function (body) {
    const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/test-adaptativo/registrar-respuesta`;
    let response = await ApiService.post(url, body);
    return response.data.success;
  },

  endTest: async function () {
    const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/test-adaptativo/finalizar`;
    let response = await ApiService.get(url);
    return response.data.data;
  },

  /**
  * Logout the current user by removing the token from storage.
  *
  * Will also remove 'Authorization Bearer <token>' header from future requests.
  **/
  logout () {
    TokenService.removeToken();
    ApiService.removeHeader();
    ApiService.unmount401Interceptor();
  }
};

export default UserService;

export { UserService, AuthenticationError };
